export default {
  name: 'MwColorSelect',
  template: `<div ref="mountPoint" style="margin-top:4px;"></div>`,
  data() {
    return {
      valueChange:false,
      chooserChange:false
    }
  },
  props: {
    value: {
      default: ""
    },
    onChange: {
      type: Function,
      default() {

      }
    }
  },
  defaultProps: {},
  mounted() {
    let mountPoint = this.mwRef("mountPoint")
    let colorChooser = new ($WR.require('form/default/ColorPicker'))({hideLabel:true});
    colorChooser.render(mountPoint);
    colorChooser.setValue(this.value);
    this.colorChooser = colorChooser;
    colorChooser.on("change", e => {
      let value = this.colorChooser.getValue();
      if (!this.valueChange && value !== this.value) {
        this.chooserChange=true;
        this.$emit("input", value);
        this.onChange();
      }
    })
  },

  watch: {
    value(val, oval) {
      if (this.colorChooser && !this.chooserChange) {
        this.valueChange=true;
        this.colorChooser.setValue(val);
      }
      this.valueChange=false;
      this.chooserChange=false;
    }
  },

  beforeDestroy() {
    if (this.colorChooser) {
      this.colorChooser.destroy();
      this.colorChooser = null;
    }

  }
}



// WEBPACK FOOTER //
// ./src/modules/index/components/color-select/index.js